import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

type ProductListPriceLabelProps = {
  isOfferMirakl: boolean
  isPrescriptionProduct: boolean
  isThirtyDayPriceTrendDown: boolean
  showThirtyDaysPrice: boolean
}

export const ProductListPriceLabel: FC<ProductListPriceLabelProps> = ({
  isOfferMirakl,
  isPrescriptionProduct,
  isThirtyDayPriceTrendDown,
  showThirtyDaysPrice,
}) => {
  if (showThirtyDaysPrice && isThirtyDayPriceTrendDown) {
    return (
      <span className="whitespace-nowrap">
        <FormattedMessage id="general.label.thirtyDaysPrice" />
      </span>
    )
  }

  const dynamicListPriceLabel = isPrescriptionProduct ? (
    <FormattedMessage id="general.label.listPriceAvp" />
  ) : (
    <FormattedMessage id="general.label.listPrice" />
  )

  return (
    <span className="whitespace-nowrap">
      {isOfferMirakl ? (
        <FormattedMessage id="general.label.miraklListPrice" />
      ) : (
        dynamicListPriceLabel
      )}
    </span>
  )
}
